export const config = {
  title: 'Payment successful',
  paraTitle: 'You have completed your payment for application.',
  subTitle: 'Application Payment is done',
  para1: 'View your applications in applications being processed tab',
  link: '/applications-being-processed',
  linkText: '',
  // "para2": " here.",
};
